<template>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
      <fg-input
        type="text"
        :label="`${$t('common_words.code')}:`"
        v-model="model.code"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        type="text"
        :label="`${$t('common_words.name')}: *`"
        v-model="model.name"
        name="common_words.name"
        v-validate="modelValidations.name"
        :error="getError('common_words.name', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
      <div class="form-group has-label">
        <label>{{ $t('inventory.warehouse_type') }}: *</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select shadow-sm required-warehouse_type"
          size="large"
          v-model="model.type"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            class="select-primary"
            v-for="item in getTypeSupplying"
            :key="item.id + item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
      <fg-input
        type="text"
        :label="`${$t('inventory.max_capacity')}:`"
        v-model="model.maximum_capacity"
        name="inventory.max_capacity"
        v-validate="modelValidations.maximum_capacity"
        :error="getError('inventory.max_capacity', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
      <div class="form-group has-label">
        <label>{{ $t('labor.unit') }}:</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select mb-3 shadow-sm required-supplying_unit"
          v-model="model.supplying_unit_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            class="select-primary"
            v-for="option in supplyingUnits"
            :label="option.name"
            :value="option.id"
            :key="option.id + option.name"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        type="text"
        :label="`${$t('common_words.address')}:`"
        v-model="model.address"
        placeholder="..."
      ></fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        ref="lat"
        type="text"
        name="common_words.latitude"
        :label="`${$t('common_words.latitude')}: `"
        v-model="model.latitude"
        :error="getError('common_words.latitude', true)"
      ></fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        ref="long"
        type="text"
        name="common_words.longitude"
        :label="`${$t('common_words.longitude')}: `"
        v-model="model.longitude"
        :error="getError('common_words.longitude', true)"
      ></fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <fg-input
        ref="altitude"
        type="text"
        name="common_words.altitude"
        :label="`${$t('common_words.altitude')}: `"
        v-model="model.altitude"
        :error="getError('common_words.altitude', true)"
      ></fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <div class="form-group has-label">
        <label>{{ $t('common_words.farms2') }}: </label>
        <br />
        <el-select
          @change="selectAllFromSelect('model.farms_id', farms)"
          collapse-tags
          clearable
          filterable
          multiple
          class="select-primary custom-width-select shadow-sm required-farms"
          size="large"
          v-model="model.farms_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in farms"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="index + option.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12">
      <select-businesses-component
        ref="selectBusiness"
        :requiered="true"
        :initialData="businessesInitial"
        @onChange="updateSelectedBusinesses"
        @showHideLoading="showHideLoading"
      />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { extendValidators } from 'src/util/vValidateCustom.js';
import Businesses from 'src/components/Selects/Businesses.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Businesses.name]: Businesses,
  },
  data() {
    return {
      farms: [],
      supplyingUnits: [],
      businessesInitial: [],
      businesses: [],
      model: {
        code: null,
        name: null,
        type: null,
        maximum_capacity: null,
        supplying_unit_id: null,
        supplying_unit_name: null,
        address: null,
        latitude: null,
        longitude: null,
        altitude: null,
        farms_id: [],
        farms_name: [],
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: { required: true },
        maximum_capacity: { positive_decimal: true },
      },
    };
  },
  computed: {
    getTypeSupplying() {
      return [
        {
          id: '1',
          value: 'Fisica',
          label: i18n.t('inventory.physical'),
        },
        {
          id: '2',
          value: 'Virtual',
          label: i18n.t('inventory.virtual'),
        },
      ];
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    getNameOfSupplyingUnit() {
      const supplyingUnitName = this.supplyingUnits.filter(
        (unit) => unit.id == this.model.supplying_unit_id
      );
      this.model.supplying_unit_name = supplyingUnitName[0].name;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('warehouse_type');
          } else if (
            (isset(this.model.maximum_capacity) &&
              !isset(this.model.supplying_unit_id)) ||
            (!isset(this.model.maximum_capacity) &&
              isset(this.model.supplying_unit_id))
          ) {
            SweetAlert.warning(
              i18n.t('inventory.invalid_max_capacity_supplying_unit')
            );

            return false;
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          }
          if (isset(this.model.farms_id)) {
            this.model.farms_name = this.getNameOfData(
              this.model.farms_id,
              this.farms
            );
          }
          if (isset(this.model.supplying_unit_id)) {
            this.getNameOfSupplyingUnit();
          }
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
  },
  created() {
    extendValidators();
  },
  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('inventory/supplyingunit'),
        Axios.getMasters('businesses/only'),
      ])
        .then(([responseFarms, responseUnit, responseBussinesses]) => {
          this.farms = this.concatAll(responseFarms.data.data);
          this.supplyingUnits = responseUnit.data.data;
          this.businesses = responseBussinesses.data.data;
          const editForm = sessionStorage.getItem('editForm');
          if (this.isUpdate() && editForm) {
            const {
              id,
              code,
              name,
              type,
              maximum_capacity,
              supplying_unit_id,
              address,
              latitude,
              longitude,
              altitude,
              farms,
            } = JSON.parse(editForm);
            this.model = {
              ...this.model,
              id,
              code,
              name,
              type,
              maximum_capacity,
              supplying_unit_id,
              address,
              latitude,
              longitude,
              altitude,
              farms_id: farms.map((farm) => farm.id),
            };
          }
          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (
      this.businesses &&
      this.businesses.length === 1 &&
      this.model.businesses_id.length === 0
    ) {
      this.model.businesses_id.push(this.businesses[0].id);
    }
  },
};
</script>
